import React from 'react';
import { TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const TermsVendors = () => {
  const sections = [
    {
      title: '1. Objet',
      content: 'Les présentes CGU encadrent la participation au programme vendeur IPTV4KFR.'
    },
    {
      title: '2. Statut du vendeur',
      content: (
        <div>
          <p>Le vendeur agit en tant que <strong className="text-[#FFB800]">apporteur de recommandation</strong>.</p>
          <p className="mt-2">Il n'est ni salarié, ni représentant exclusif de la plateforme.</p>
        </div>
      )
    },
    {
      title: '3. Accès à l\'espace vendeur',
      content: (
        <div>
          <p className="mb-3">Après inscription, le vendeur dispose d'un espace dédié permettant :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>Le suivi des ventes</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>La consultation des commissions</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">✓</span>
              <span>La gestion des paiements</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '4. Commissions',
      content: (
        <div>
          <p className="mb-3">Les commissions :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Sont calculées automatiquement</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Dépendent des paliers mensuels définis</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">•</span>
              <span>Sont visibles dans l'espace vendeur</span>
            </li>
          </ul>
          <div className="mt-4 bg-[#FFB800]/10 border border-[#FFB800]/30 p-3 rounded-lg">
            <p className="text-[#FFB800] text-sm">Les paliers sont recalculés chaque mois sur la base du mois précédent (M-1).</p>
          </div>
        </div>
      )
    },
    {
      title: '5. Paiements',
      content: (
        <div>
          <p className="mb-3">Les paiements :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>Sont effectués via PayPal</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>À partir d'un seuil minimum défini (50€)</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#00FF88] mt-1">•</span>
              <span>Sur demande du vendeur</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '6. Obligations du vendeur',
      content: (
        <div>
          <p className="mb-3">Le vendeur s'engage à :</p>
          <ul className="space-y-2 ml-4">
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">✓</span>
              <span>Présenter l'offre de manière honnête</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">✓</span>
              <span>Ne pas faire de promesses non prévues par la plateforme</span>
            </li>
            <li className="flex items-start space-x-2">
              <span className="text-[#FF6B35] mt-1">✓</span>
              <span>Respecter l'image et la réputation d'IPTV4KFR</span>
            </li>
          </ul>
        </div>
      )
    },
    {
      title: '7. Suspension du compte vendeur',
      content: 'IPTV4KFR se réserve le droit de suspendre ou fermer un compte vendeur en cas de comportement abusif ou contraire aux règles.'
    },
    {
      title: '8. Évolution du programme',
      content: 'Le programme vendeur peut évoluer. Les conditions applicables sont celles affichées dans l\'espace vendeur.'
    }
  ];

  return (
    <div className="min-h-screen py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <div className="inline-block p-4 bg-[#FFB800]/10 rounded-full mb-6">
            <TrendingUp className="h-12 w-12 text-[#FFB800]" />
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Conditions Générales d'Utilisation
          </h1>
          <p className="text-[#B8B8BA] text-lg mb-2">
            Pour les vendeurs
          </p>
        </motion.div>

        <div className="space-y-6">
          {sections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.05 * index }}
              className="bg-gradient-to-br from-[#1A1A1D] to-[#121214] p-6 rounded-xl border border-white/10"
            >
              <h2 className="text-xl font-bold text-white mb-3">
                {section.title}
              </h2>
              <div className="text-[#E8E8E8] leading-relaxed">
                {section.content}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
          className="mt-12 bg-gradient-to-br from-[#FF6B35]/10 to-[#F7931E]/10 p-8 rounded-xl border border-[#FF6B35]/30 text-center"
        >
          <p className="text-white text-lg mb-4">
            Prêt à rejoindre la team IPTV4KFR ?
          </p>
          <Link
            to="/devenir-vendeur"
            className="inline-block bg-gradient-to-r from-[#FF6B35] to-[#F7931E] text-white font-semibold px-8 py-3 rounded-lg hover:shadow-xl hover:shadow-[#FF6B35]/50 transition-all duration-300"
          >
            Devenir vendeur
          </Link>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsVendors;
